import script from "./upSafeguardProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./upSafeguardProduct.vue?vue&type=script&setup=true&lang=js"

import "./upSafeguardProduct.vue?vue&type=style&index=0&id=5bf4c50a&lang=scss&scoped=true"
import "./upSafeguardProduct.vue?vue&type=style&index=1&id=5bf4c50a&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf4c50a"]])

export default __exports__